<script>
    import AXHR from "../js/axhr.js";
    import { session } from "../js/store.js";
    import { onInterval } from "../js/intervall.js";
    let sessions;
    $: sessions;
    session.subscribe((value) => {
        sessions = value;
    });
    let errorEvent = 0;
    let nextInterval = true;
    let LogsData = [];
    function loadLogsData(endpoint, token) {
        if (errorEvent < 1) {
            var config = {
                method: "get",
                url: endpoint,
                headers: {
                    Authorization: "Bearer " + token,
                },
            };

            AXHR(config)
                .then(function (response) {
                    nextInterval = true;
                    errorEvent = 0;
                    LogsData = response.data;
                })
                .catch(function (error) {
                    nextInterval = false;
                    errorEvent = errorEvent + 1;
                });
        }
    }
    function tryloadLogsData() {
        console.log("triggered");
        errorEvent = 0;
        loadLogsData(
            sessions.api + "/rb/" + sessions.routeractive.id + "/logs",
            sessions.token,
            sessions.routeractive.iface
        );
    }
    const tryload = tryloadLogsData();
    $: if (nextInterval) {
        onInterval(() => {
            loadLogsData(
                sessions.api + "/rb/" + sessions.routeractive.id + "/logs",
                sessions.token,
                sessions.routeractive.iface
            );
        }, 10000);
    }
</script>

<div class="relative py-5 my-5 bg-white rounded-lg shadow-lg">
    <h2 class="text-sm font-bold text-center">Log Hotspot</h2>
    <div
        class="sticky top-0 w-full my-2 overflow-hidden bg-white shadow-md lg:my-1 md:my-1"
    >
        <div class="flex flex-wrap justify-start w-full px-2 text-sm">
            <div class="w-4/12 p-2 lg:w-3/12 md:w-3/12">Time</div>

            <div class="w-8/12 p-2 lg:w-9/12 md:w-9/12">Message</div>
        </div>
    </div>
    <div class="p-2 overflow-y-auto h-96">
        {#if LogsData.length > 0}
            {#each LogsData as d}
                <div
                    class="w-full mx-0 my-1 overflow-hidden text-gray-600 shadow lg:my-1 md:my-1 hover:bg-gray-100"
                >
                    <div
                        class="flex flex-wrap items-start justify-start w-full"
                    >
                        <div
                            class="flex items-start justify-start w-4/12 p-2 text-xs lg:w-3/12 md:w-3/12"
                        >
                            {String(d.time)}
                        </div>

                        <div
                            title={String(d.message)}
                            class="flex items-start justify-start w-8/12 p-2 text-xs leading-6 text-gray-700 align-top lg:w-9/12 md:w-9/12"
                        >
                            {String(d.message)}
                        </div>
                    </div>
                </div>
            {/each}
        {/if}
    </div>
</div>
